import { STEPPER_GLOBAL_OPTIONS, StepperSelectionEvent } from '@angular/cdk/stepper';
import { Component, Input, OnDestroy } from '@angular/core';
import { StepperOrientation } from '@angular/material/stepper';
import { WizardStep } from '@app/shared/models/wizard-step';
import { Subscription } from 'rxjs';
import { DeviceService } from '@app/shared/helpers/device.service';
import { DeviceType } from '@app/shared/enum/device-type';

@Component({
    selector: 'app-wizard',
    templateUrl: './wizard.component.html',
    styleUrls: ['./wizard.component.scss'],
    providers: [
        {
            provide: STEPPER_GLOBAL_OPTIONS,
            useValue: { displayDefaultIndicatorType: false },
        },
    ],
    standalone: false,
})
export class WizardComponent implements OnDestroy {
    @Input() steps: WizardStep[];
    @Input() currentStep: WizardStep;

    orientation: StepperOrientation = 'horizontal';

    private deviceSubscription: Subscription;

    constructor(private deviceService: DeviceService) {
        this.deviceSubscription = this.deviceService.deviceType$.subscribe((type) => {
            this.orientation = type === DeviceType.mobile ? 'vertical' : 'horizontal';
        });
    }

    onSelectionChange(event: StepperSelectionEvent): void {
        this.steps.forEach((step) => {
            step.completed = step.index <= event.selectedIndex;
        });
    }

    ngOnDestroy(): void {
        this.deviceSubscription.unsubscribe();
    }
}
